"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _paymentMethodsSlice = require("../../../redux/paymentMethodsSlice");
var _store = require("../../../redux/store");
var _DropInSectionStyled = require("./DropInSectionStyled");
var _jsxRuntime = require("react/jsx-runtime");
var PayPalIcon = function PayPalIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        style: {
          fill: "none"
        },
        d: "M0 0h25.576v30.177H0z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M0 0h25.576v30.177H0z"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        clipPath: "url(#a)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m7.266 29.154.523-3.322-1.165-.027H1.061L4.927 1.292a.316.316 0 0 1 .314-.268h9.38c3.114 0 5.263.648 6.385 1.927.526.6.861 1.227 1.023 1.917.17.724.173 1.589.007 2.644l-.012.077v.676l.526.298a3.69 3.69 0 0 1 1.065.812c.45.513.741 1.165.864 1.938.127.795.085 1.741-.123 2.812-.24 1.232-.628 2.305-1.152 3.183a6.547 6.547 0 0 1-1.825 2c-.696.494-1.523.869-2.458 1.109-.906.236-1.939.355-3.072.355h-.73c-.522 0-1.029.188-1.427.525a2.21 2.21 0 0 0-.744 1.328l-.055.299-.924 5.855-.042.215c-.011.068-.03.102-.058.125a.155.155 0 0 1-.096.035H7.266Z",
          style: {
            fill: "#253b80",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M23.048 7.667c-.028.179-.06.362-.096.55-1.237 6.351-5.469 8.545-10.874 8.545H9.326c-.661 0-1.218.48-1.321 1.132L6.596 26.83l-.399 2.533a.704.704 0 0 0 .695.814h4.881c.578 0 1.069-.42 1.16-.99l.048-.248.919-5.832.059-.32c.09-.572.582-.992 1.16-.992h.73c4.729 0 8.431-1.92 9.513-7.476.452-2.321.218-4.259-.978-5.622a4.667 4.667 0 0 0-1.336-1.03Z",
          style: {
            fill: "#179bd7",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M21.754 7.151a9.757 9.757 0 0 0-1.203-.267 15.284 15.284 0 0 0-2.426-.177h-7.352a1.172 1.172 0 0 0-1.159.992L8.05 17.605l-.045.289a1.336 1.336 0 0 1 1.321-1.132h2.752c5.405 0 9.637-2.195 10.874-8.545.037-.188.068-.371.096-.55a6.594 6.594 0 0 0-1.017-.429 9.045 9.045 0 0 0-.277-.087Z",
          style: {
            fill: "#222d65",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M9.614 7.699a1.169 1.169 0 0 1 1.159-.991h7.352c.871 0 1.684.057 2.426.177a9.757 9.757 0 0 1 1.481.353c.365.121.704.264 1.017.429.368-2.347-.003-3.945-1.272-5.392C20.378.682 17.853 0 14.622 0h-9.38c-.66 0-1.223.48-1.325 1.133L.01 25.898a.806.806 0 0 0 .795.932h5.791l1.454-9.225 1.564-9.906Z",
          style: {
            fill: "#253b80",
            fillRule: "nonzero"
          }
        })]
      })]
    })
  });
};
PayPalIcon.defaultProps = {
  viewBox: "0 0 26 31",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve"
};
const DropInSection = _ref => {
  let {
    children,
    selectPaymentMethod,
    title,
    logo,
    isLoading
  } = _ref;
  const {
    selectedPaymentMethod
  } = (0, _store.useAppSelector)(_paymentMethodsSlice.selectPaymentMethods);
  const isSelected = (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.methodName) === title.toLowerCase();
  const fadeOutSection = isLoading && (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.methodName) !== title.toLowerCase();
  const mapImage = {
    paypal: PayPalIcon
  };
  const LogoComponent = logo === 'paypal' ? mapImage[logo] : null;
  const handleOnClick = () => {
    if (!fadeOutSection && (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.methodName) !== 'paypal') {
      selectPaymentMethod('paypal');
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropInSectionStyled.WrapperStyled, {
    isSelected: isSelected,
    onClick: handleOnClick,
    fadeOutSection: fadeOutSection,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropInSectionStyled.TextStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames.default)('adyen-checkout__payment-method__radio', {
          'adyen-checkout__payment-method__radio--selected': isSelected
        }),
        "aria-hidden": !isSelected
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropInSectionStyled.IconWrapperStyled, {
        children: LogoComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoComponent, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropInSectionStyled.TitleStyled, {
        children: title
      })]
    }), isSelected && children]
  });
};
var _default = exports.default = DropInSection;